import { Button, Form } from 'react-bootstrap'
import { ContextSubject } from './EnableSubject'
import { useContext, useState } from 'react'

export function TableSubjectRow({ subject, faculties }) {
    const { showModalSchedules } = useContext(ContextSubject)
    const { nombre, codigo, periodo, gestion, facultad_id } = subject[0]
    const [error, setError] = useState(false)
    const [faculty, setFaculty] = useState('')

    const handleShowSchedule = () => {
        // if (faculty > 0) {
            showModalSchedules(facultad_id, subject)
        // } else {
        //     setError(true)
        // }
    }
    const handleOnChangeFaculty = (e) => {
        setError(false)
        setFaculty(e.target.value)
    }

    return (
        <tr>
            <td>{nombre}</td>
            <td>{codigo}</td>
            <td className='text-center'>{gestion}</td>
            <td className='text-center'>{periodo}</td>
            <td>
                <Form.Select
                    value={facultad_id}
                    onChange={(e) => e.preventDefault()}
                    // onChange={handleOnChangeFaculty}
                    disabled
                >
                    <option value={0}>Seleccione una facultad</option>
                    {
                        faculties.map((faculty) => (
                            <option key={faculty.id} value={faculty.id}>
                                {faculty.nombre}
                            </option>
                        ))
                        // faculties[`${gestion}-${periodo}`]?.map((faculty) =>
                        // <option key={faculty.id} value={faculty.facultad_id}>
                        //     {faculty.nombre}
                        // </option>)
                    }
                </Form.Select>
                {error && <p className='sms-error'>*Seleccione una facultad</p>}
            </td>
            <td className='col-2'>
                <div className='d-flex justify-content-center'>
                    <Button onClick={() => handleShowSchedule()} variant='blue'>
                        Habilitar Materia
                    </Button>
                </div>
            </td>
        </tr>
    )
}
